import { ContactStatusOption } from '../proto/tumelo/fundoutreach/v1/contact_status';
const prefix = 'fundManagers/';
export const IDToName = ({ fundManagerID }) => {
    return prefix + fundManagerID;
};
export const nameToID = (name) => {
    if (!validateName(name)) {
        throw new Error(`bad fund manager name: ${name}`);
    }
    const parts = name.split('/');
    return { fundManagerID: parts[1] };
};
export const validateName = (name) => {
    const parts = name.split('/');
    return parts.length === 2 && name.startsWith(prefix);
};
export const contactStatusToString = (o) => {
    switch (o) {
        case ContactStatusOption.CONTACT_STATUS_INVALID:
            return 'Select';
        case ContactStatusOption.UNRECOGNIZED:
            return 'Unrecognized';
        case ContactStatusOption.UNKNOWN:
            return 'Unknown';
        case ContactStatusOption.NO_CONTACT:
            return 'No contact';
        case ContactStatusOption.INITIAL_CONTACT_MADE:
            return 'Initial contact made';
        case ContactStatusOption.DISCUSSIONS_IN_PROGRESS:
            return 'Discussions in progress';
        case ContactStatusOption.INITIAL_DATA_RECEIVED:
            return 'Initial data received';
        case ContactStatusOption.DATA_FEED_ESTABLISHED:
            return 'Data feed established';
    }
};
export const relationshipOwnerToName = (owner) => {
    return owner
        .replace('@tumelo.com', '')
        .split('.')
        .map((lowercase) => `${lowercase[0].toUpperCase()}${lowercase.slice(1)}`)
        .join(' ');
};
